import React from "react";
import { ShieldCheckIcon } from "lucide-react";
export function Guarantee() {
  return <section className="bg-white px-5 py-12" data-id="element-93" data-mp="1o4exyguev08v">
      <div className="mx-auto max-w-md" data-id="element-94" data-mp="1o3dj01a9xtlv">
        <div className="rounded-2xl border-2 border-brand/30 bg-brand/5 p-6 text-center" data-id="element-95" data-mp="223y5b7fee7k4">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-brand text-white" data-id="element-96" data-mp="1x4l7xsqwhi3a">
            <ShieldCheckIcon className="h-8 w-8" data-id="element-97" data-mp="19dzcd0y31qa6" />
          </div>
          <h2 className="font-display text-xl font-extrabold text-navy-800" data-id="element-98" data-mp="19cek5hz8qjfh">🛡️ Garantía de 7 Días</h2>
          <p className="mt-3 text-sm leading-relaxed text-navy-800/70" data-id="element-99" data-mp="1j4k5w9ywg4m8">
            Queremos que revises el material con tranquilidad. Si durante los primeros 7 días
            consideras que el Sistema Antirrefinamientos no cumple con tus expectativas, solo
            escríbenos y procesaremos tu reembolso.
          </p>
          <p className="mt-3 font-display text-base font-bold text-brand-dark" data-id="element-100" data-mp="lpy8i5bumy13">Sin complicaciones.</p>
        </div>
      </div>
    </section>;
}